import { Link } from "react-router-dom";
import { Logo } from "../components/Logo.jsx";

const FOOTER_LINKS = {
  Ecosystem: ["Gig Projects", "Marketplace", "Academy", "Studio", "Fund"],
  Tribe: ["For talent", "For companies", "For builders", "Events", "Co-live"],
  Elsewhere: ["Journal", "Instagram", "LinkedIn", "Newsletter", "Contact"],
};

export function Footer() {
  return (
    <footer className="shell" id="journal">
      <div className="foot">
        <div>
          <Logo />
          <p className="foot-tagline">
            A movement disguised as a company. Built for the people the
            old system forgot.
          </p>
        </div>
        {Object.entries(FOOTER_LINKS).map(([title, links]) => (
          <div key={title}>
            <h4>{title}</h4>
            <ul>
              {links.map((label) => (
                <li key={label}>
                  <Link to="/apply">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="foot-bottom">
        <span>© 2026 Alt Tribe — All rights reserved</span>
        <span>Made by people · with AI · in India</span>
      </div>
    </footer>
  );
}
